import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import GameLibraryPage from './pages/GameLibraryPage';
import HomePage from './pages/HomePage';
import GamePage from './pages/GamePage';
import SettlementPage from './pages/SettlementPage';
import GomokuLobbyPage from './pages/GomokuLobbyPage';
import GomokuRoomPage from './pages/GomokuRoomPage';
import ProfileStatsPage from './pages/ProfileStatsPage';
import AdminPage from './pages/AdminPage';
import LegacyTexasHoldemRedirect from './routes/LegacyTexasHoldemRedirect';
import {
  GOMOKU_LOBBY_ROUTE,
  GOMOKU_ROOM_ROUTE,
  TEXAS_HOLDEM_LOBBY_ROUTE,
  TEXAS_HOLDEM_ROOM_ROUTE,
  TEXAS_HOLDEM_SETTLEMENT_ROUTE
} from './games/routes';
import './styles.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="mobile-shell">
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/"
              element={(
                <ProtectedRoute>
                  <GameLibraryPage />
                </ProtectedRoute>
              )}
            />
            <Route
              path={TEXAS_HOLDEM_LOBBY_ROUTE}
              element={(
                <ProtectedRoute>
                  <HomePage />
                </ProtectedRoute>
              )}
            />
            <Route
              path={TEXAS_HOLDEM_ROOM_ROUTE}
              element={(
                <ProtectedRoute>
                  <GamePage />
                </ProtectedRoute>
              )}
            />
            <Route
              path={TEXAS_HOLDEM_SETTLEMENT_ROUTE}
              element={(
                <ProtectedRoute>
                  <SettlementPage />
                </ProtectedRoute>
              )}
            />
            <Route
              path={GOMOKU_LOBBY_ROUTE}
              element={(
                <ProtectedRoute>
                  <GomokuLobbyPage />
                </ProtectedRoute>
              )}
            />
            <Route
              path={GOMOKU_ROOM_ROUTE}
              element={(
                <ProtectedRoute>
                  <GomokuRoomPage />
                </ProtectedRoute>
              )}
            />
            <Route
              path="/games/:roomCode/settlement"
              element={(
                <ProtectedRoute>
                  <LegacyTexasHoldemRedirect destination="settlement" />
                </ProtectedRoute>
              )}
            />
            <Route
              path="/rooms/:roomCode"
              element={(
                <ProtectedRoute>
                  <LegacyTexasHoldemRedirect />
                </ProtectedRoute>
              )}
            />
            <Route
              path="/games/:roomCode"
              element={(
                <ProtectedRoute>
                  <LegacyTexasHoldemRedirect />
                </ProtectedRoute>
              )}
            />
            <Route
              path="/stats"
              element={(
                <ProtectedRoute>
                  <ProfileStatsPage />
                </ProtectedRoute>
              )}
            />
            <Route
              path="/admin"
              element={(
                <ProtectedRoute adminOnly>
                  <AdminPage mode="users" />
                </ProtectedRoute>
              )}
            />
            <Route
              path="/admin/texas-holdem"
              element={(
                <ProtectedRoute adminOnly>
                  <AdminPage mode="texas-holdem" />
                </ProtectedRoute>
              )}
            />
            <Route
              path="/admin/gomoku"
              element={(
                <ProtectedRoute adminOnly>
                  <AdminPage mode="gomoku" />
                </ProtectedRoute>
              )}
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
